(function () {
    'use strict';

    angular
        .module('blocks.directives')
        .directive('stResetSearch', stResetSearch);

    stResetSearch.$inject = ['notifier', 'config'];
    /* @ngInject */
    function stResetSearch(notifier, config) {
        var directive = {
            restrict: 'EA',
            require: '^stTable',
            link: link,
            scope: {
                'controlId': '@'
            }

        };

        return directive;

        function link(scope, element, attrs, ctrl) {
            return element.bind('click', function () {
                return scope.$apply(function () {
                    var tableState;
                    notifier.notify(config.events.filterCleared);
                    document.getElementById(scope.controlId).value = "";
                    tableState = ctrl.tableState();
                    tableState.search.predicateObject = {};
                    tableState.pagination.start = 0;
                    return ctrl.pipe();
                });
            });
        }
    }
})();
